export default {"src":"/newStatic/_next/static/media/ring.8e46a9d5.svg","height":175,"width":92};